import React__default, { useEffect } from 'react';
import { Close } from '../../../assets/icons/Close.esm.js';
import { useKeyPress } from '@invitae/nucleobase-engine-contentful';
import NvVimeo from '../../WrappedVideo/Vimeo/Vimeo.esm.js';
import styles from './VideoPopup.module.esm.js';

var VideoPopup = React__default.forwardRef(function (_a, ref) {
    var vimeoId = _a.vimeoId, closeVideoPopup = _a.closeVideoPopup;
    var escPress = useKeyPress('Escape');
    useEffect(function () {
        var _a;
        var isOpen = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.open;
        if (escPress.pressed && isOpen)
            closeVideoPopup();
    }, [escPress, closeVideoPopup, ref]);
    return (React__default.createElement("dialog", { "aria-labelledby": "Modal with video", className: styles.wrapper, "data-testid": "dialog-video-popup", ref: ref },
        React__default.createElement("button", { className: styles.closeButton, "data-testid": "close-modal-button", onClick: closeVideoPopup, type: "button" },
            React__default.createElement(Close, null)),
        React__default.createElement("div", { className: styles.videoWrapper },
            React__default.createElement(NvVimeo, { vimeoId: vimeoId }))));
});

export { VideoPopup };
//# sourceMappingURL=VideoPopup.esm.js.map
